/** Translations of the analytics area; wired up in lib/i18n/en.ts. */
export const analyticsEs = {
  title: 'Analítica',
  subtitle:
    'Revenu, margen de contribución y estructura de clientes sobre períodos seleccionables de forma libre.',
  tabs: {
    overview: 'Visión general',
    customers: 'Clientes',
    products: 'Productos',
    geo: 'Regiones',
    employeePerformance: 'Rendimiento del empleado',
  },
  filters: {
    preset: 'período',
    dateFrom: 'Desde',
    dateTo: 'Hasta',
    comparison: 'Comparación',
    granularity: 'Granularidad',
    export: 'Exportación a CSV',
    presets: {
      last30Days: 'Últos 30 días',
      currentMonth: 'Mes actual',
      lastMonth: 'Mes anterior',
      currentQuarter: 'Cuartos actuales',
      currentYear: 'Año actual',
      lastYear: 'Año anterior',
      custom: 'Personalizado',
    },
    comparisons: {
      NONE: 'No comparación',
      PREVIOUS_PERIOD: 'Período anterior',
      PREVIOUS_YEAR: 'Año anterior',
    },
    granularities: {
      DAY: 'Día',
      WEEK: 'Semana',
      MONTH: 'Mes',
      QUARTER: 'Cuarto',
    },
  },
  validation: {
    invalidRange: 'La fecha de inicio debe ser antes de la fecha de fin.',
  },
  states: {
    error: 'El análisis no se pudo cargar.',
    empty: 'No hay datos en el período seleccionado',
    emptyHint: 'Ajusta el período o registra documentos para ver análisis.',
  },
  export: {
    success: 'La exportación ha sido creada.',
  },
  kpi: {
    netRevenue: 'Ingresos netos',
    grossProfit: 'Ganancia bruta',
    marginPct: 'Margen',
    averageOrderValue: 'Valor promedio de pedido',
    invoiceCount: 'Facturas',
    activeCustomers: 'Clientes activos',
    openReceivables: 'Cuentas por cobrar abiertas',
    cancelledOrderRatePct: 'Tasa de cancelación',
    comparedToPrevious: 'en comparación con el período de comparación',
  },
  charts: {
    revenueTitle: 'Tendencia de ingresos',
    netRevenue: 'Ingresos netos',
    grossProfit: 'Ganancia bruta',
    orderIntake: 'Entrada de pedidos',
    comparisonRevenue: 'Período de comparación',
  },
  payment: {
    title: 'Estado de pago de la factura',
    paid: 'Pagado',
    open: 'Abierto',
    overdue: 'Vencido',
  },
  customers: {
    abcClass: 'Clase {{abcClass}}',
    abcSummary: 'Clientes {{count}} · Participación de ingresos {{share}}',
    atRisk: 'En riesgo de baja',
    industryTitle: 'Ingresos por industria',
    tableTitle: 'Análisis de clientes',
    columns: {
      customer: 'Cliente',
      industry: 'Industria',
      netRevenue: 'Ingresos netos',
      grossProfit: 'Ganancia bruta',
      margin: 'Margen',
      orders: 'Pedidos',
      lastOrder: 'Último pedido',
      abc: 'ABC',
      churn: 'Rotación',
    },
    churn: {
      NONE: 'Saludable',
      WARNING: 'Vigilar',
      CRITICAL: 'Crítico',
    },
  },
  products: {
    groupTitle: 'Margen de contribución I por grupo de productos',
    tableTitle: 'Análisis de producto',
    slowMoverTitle: 'Artículos de baja rotación',
    totals: {
      netRevenue: 'Ingresos netos',
      costOfGoods: 'Costo de los bienes',
      contributionMargin1: 'Margen de contribución I',
      productCount: 'Productos',
    },
    columns: {
      product: 'Producto',
      group: 'Grupo de productos',
      quantity: 'Cantidad',
      netRevenue: 'Ingresos netos',
      contributionMargin1: 'MC I',
      contributionMargin2: 'MC II',
      margin: 'Margen',
      returnRate: 'Tasa de devolución',
      stockQuantity: 'Stock',
      stockValue: 'Valor de stock',
      lastMovement: 'Último movimiento',
      daysSinceMovement: 'Días sin movimiento',
    },
  },
  geo: {
    regionTitle: 'Ingresos por región',
    regionTableTitle: 'Regiones',
    countryTitle: 'Ingresos por país',
    regions: {
      DOMESTIC: 'Nacional',
      EU: 'UE',
      THIRD_COUNTRY: 'No perteneciente a la UE',
    },
    columns: {
      region: 'Región',
      country: 'País',
      netRevenue: 'Ingresos netos',
      documents: 'Documentos',
      customers: 'Clientes',
      share: 'Compartir',
    },
  },
  employeePerformance: {
    teamTitle: 'Resumen del equipo de desempeño de empleados',
    teamSubtitle: 'Métricas objetivas de ERP, documentos y telefonía para el período seleccionado.',
    updatedAt: 'Datos a fecha de {{date}} · Zona horaria {{timezone}}',
    emptyHint:
      'Ajuste los filtros de empleado o de negocio. Los empleados sin actividad permanecen disponibles.',
    minutes: '{{value}} min',
    noComparison: 'No hay un valor de comparación significativo',
    comparisonValue: 'Valor de comparación: {{value}}',
    showDefinition: 'Mostrar definición de {{metric}}',
    chartAriaLabel: 'Cronología de ingresos y órdenes recibidas',
    telephonyChartAriaLabel: 'Cronología de llamadas CTI y duración de llamadas',
    chartDescription:
      'Gráfico con intervalos de tiempo {{count}}. Los valores también están disponibles en métricas y tablas.',
    privacy: {
      title: 'Uso responsable de los datos de empleados',
      description:
        'Este análisis está destinado exclusivamente al análisis del rendimiento operativo. Las métricas requieren un contexto empresarial y no deben ser la única base para decisiones automatizadas de empleo. El contenido de comunicación, audio, transcripciones, resúmenes de IA, características de sentimiento y personalidad no se muestran ni se evalúan.',
    },
    activation: {
      title: 'El rendimiento del empleado está deshabilitado',
      description:
        'La función está deshabilitada para este inquilino. Habilitarla no almacena nuevos datos de rendimiento en crudo; agrega los datos existentes de ERP con alcance en el inquilino.',
      legalReview:
        'Antes de la activación en producción, revise las obligaciones de aviso, las políticas del lugar de trabajo, la base legal y cualquier derecho de participación de la representación de los empleados.',
      enable: 'Habilitar después de la revisión',
      disable: 'Deshabilitar análisis',
      enabledSuccess: 'El rendimiento del empleado ha sido habilitado para este inquilino.',
      disabledSuccess: 'El rendimiento del empleado ha sido desactivado para este inquilino.',
    },
    status: {
      active: 'Activo',
      inactive: 'Inactivo',
      unassigned: 'No asignado',
    },
    filters: {
      employees: 'Empleados',
      allEmployees: 'Todos los empleados',
      selectedCount: '{{count}} seleccionado',
      clearSelection: 'Borrar selección',
      employeeStatus: 'Estado del empleado',
      employeeStatuses: {
        ACTIVE: 'Solo activos',
        INACTIVE: 'Solo inactivos',
        ALL: 'Activos e inactivos',
      },
      documentTypes: 'Tipos de documentos',
      allDocumentTypes: 'Todos los documentos de ventas',
      documentStatuses: 'Estados de documentos',
      allDocumentStatuses: 'Todos los estados relevantes',
      phoneDirections: 'Dirección de llamada',
      allPhoneDirections: 'Entrante y saliente',
      phoneDirection: {
        INBOUND: 'Entrante',
        OUTBOUND: 'Saliente',
      },
      customerGroups: 'Grupos de clientes',
      countryCodes: 'Países',
      salesRegions: 'Territorios de ventas',
      commaSeparated: 'Separados por comas',
      conversionWindow: 'Ventana de contacto (días)',
      includeUnassigned: 'Incluir datos no asignados',
    },
    kpis: {
      netRevenue: {
        label: 'Ingreso neto del equipo',
        definition:
          'Montos netos relevantes de facturas menos cancelaciones y notas de crédito registradas; fecha: fecha del documento, atribución: instantánea auditable del representante de ventas.',
      },
      orderIntake: {
        label: 'Entrada de pedidos',
        definition:
          'Valor neto de pedidos confirmados, activos, parcialmente procesados o completados por fecha de documento y atribución de ventas.',
      },
      grossProfit: {
        label: 'Ganancia bruta',
        definition:
          'Ingreso neto facturado incluyendo correcciones negativas menos el costo congelado de los bienes en los ítems del documento.',
      },
      totalCalls: {
        label: 'Llamadas',
        definition:
          'Entradas únicas CTI/Ringover del CommunicationLog por hora de inicio y CommunicationLog.userId. Se excluyen entradas manuales de CallLog.',
      },
      quoteToOrderConversionPct: {
        label: 'Conversión de cotizaciones',
        definition:
          'Participación ponderada del equipo en cotizaciones relevantes con un pedido de seguimiento calificado a través de sourceDocumentId; no se realiza estimación de similitud.',
      },
    },
    chart: {
      title: 'Ingresos, pedidos y telefonía a lo largo del tiempo',
      netRevenue: 'Ingresos netos',
      orderIntake: 'Entrada de pedidos',
      comparisonRevenue: 'Comparación de ingresos netos',
      calls: 'Llamadas CTI',
      callDuration: 'Duración de llamadas CTI',
    },
    unassigned: {
      title: 'Documentos no asignados',
      description:
        'Estos valores no tienen una atribución de ventas confiable y deliberadamente no se acreditan a una persona. Las llamadas CTI se asignan técnicamente a un usuario.',
    },
    table: {
      title: 'Empleados ({{count}})',
      employee: 'Empleado',
      status: 'Estado',
      netRevenue: 'Ingresos netos facturados',
      orderIntake: 'Entrada de pedidos',
      grossProfit: 'Ganancia bruta',
      margin: 'Margen',
      quotes: 'Cotizaciones',
      orders: 'Pedidos',
      invoices: 'Facturas',
      quoteConversion: 'Conversión de cotizaciones',
      averageOrderValue: 'Valor promedio de pedido',
      calls: 'Llamadas',
      callDuration: 'Duración de llamadas',
      reachability: 'Capacidad de contacto',
      customers: 'Clientes atendidos',
      comparison: 'Comparación de períodos',
      documents: 'Documentos',
      documentSummary: 'Cotizaciones {{quotes}} · Pedidos {{orders}} · Facturas {{invoices}}',
      columns: 'Columnas',
      visibleColumns: 'Columnas visibles',
      openEmployee: 'Abrir detalles de {{name}}',
      page: 'Página {{page}} de {{pages}} · Entradas {{count}}',
      columnLabels: {
        isActive: 'Estado',
        netRevenue: 'Ingresos netos facturados',
        orderIntake: 'Entrada de pedidos',
        grossProfit: 'Ganancia bruta',
        marginPct: 'Margen',
        quoteCount: 'Cotizaciones',
        orderCount: 'Pedidos',
        invoiceCount: 'Facturas',
        quoteToOrderConversionPct: 'Conversión de cotizaciones',
        averageOrderValue: 'Valor promedio de pedido',
        totalCalls: 'Llamadas',
        totalCallDurationSeconds: 'Duración de llamadas',
        reachabilityPct: 'Capacidad de contacto',
        servedCustomerCount: 'Clientes atendidos',
        comparisonDeltaPct: 'Comparación de períodos',
      },
    },
    funnel: {
      QUOTE: 'Cotizaciones',
      ORDER: 'Pedidos',
      DELIVERY_NOTE: 'Notas de entrega',
      INVOICE: 'Facturas',
    },
    detail: {
      title: 'Detalles del empleado',
      description:
        'Métricas de negocio agregadas sin contenido de comunicación ni evaluación de personalidad.',
      updatedAt: 'Datos a fecha de {{date}}',
      development: 'Tendencia propia y periodo de comparación',
      funnel: 'Embudo de documentos: cotización → pedido → albarán → factura',
      salesMetrics: 'Ventas, ingresos y calidad de documentos',
      telephony: 'Agregado de telefonía',
      telephonyPrivacy:
        'Las llamadas de clientes registradas manualmente se muestran por separado. El audio, números de teléfono, transcripciones, contenido, resúmenes y sentimientos no se procesan aquí.',
      quality: 'Calidad y correcciones',
      customerActivities: 'Actividad documentada de clientes por canal',
      customerStructure: 'Estructura del cliente',
      definitions: 'Definiciones de métricas y base de datos',
      inboundCalls: 'Entrante',
      outboundCalls: 'Saliente',
      answeredCalls: 'Contestadas',
      missedCalls: 'Perdidas (entrantes)',
      notReachedCalls: 'No contactadas (salientes)',
      failedCalls: 'Fallidas técnicamente',
      callDuration: 'Duración total',
      averageCallDuration: 'Duración promedio de llamadas respondidas',
      unknownNumbers: 'Números no asignados',
      manualCalls: 'Llamadas manuales de clientes',
      corrections: 'Valor de cancelación/nota de crédito',
      cancellationRate: 'Tasa de corrección',
      fullyPaidRate: 'Pagado en su totalidad',
      averageDiscount: 'Tasa de descuento promedio',
      openFollowUps: 'Seguimientos abiertos',
      overdueFollowUps: 'Seguimientos vencidos',
      partnerAssigned: 'Con socio comercial',
      technicallyProcessed: 'Completado técnicamente',
      newCustomerRevenue: 'Ingresos de nuevos clientes',
      existingCustomerRevenue: 'Ingresos de clientes existentes',
      newCustomers: 'Nuevos clientes',
      reactivatedCustomers: 'Clientes reactivados',
      customer: 'Cliente',
      noCustomers: 'No hay clientes atribuibles de manera confiable en este período.',
      summary: {
        netRevenue: 'Ingresos netos',
        orderIntake: 'Entrada de pedidos',
        grossProfit: 'Ganancia bruta',
        marginPct: 'Margen',
        totalCalls: 'Llamadas CTI',
        reachabilityPct: 'Capacidad de contacto',
        servedCustomerCount: 'Clientes atendidos',
        netRevenueComparison: 'Cambio en ingresos',
      },
    },
    definitionLabels: {
      netRevenue: 'Ingresos netos facturados',
      grossRevenue: 'Ingresos brutos facturados',
      paidNetRevenue: 'Ingresos netos pagados',
      openInvoiceAmount: 'Monto de factura pendiente',
      overdueInvoiceAmount: 'Importe de factura vencida',
      correctionValue: 'Valor de cancelación y nota de crédito',
      correctionCount: 'Documentos de cancelación y corrección',
      costOfGoods: 'Costo de los bienes',
      grossProfit: 'Ganancia bruta',
      marginPct: 'Margen bruto',
      averageInvoiceValue: 'Valor promedio de factura',
      revenueSharePct: 'Participación en los ingresos del equipo',
      orderIntake: 'Entrada de pedidos',
      quoteCount: 'Cotizaciones',
      quoteValue: 'Valor neto de la cotización',
      orderCount: 'Pedidos',
      orderValue: 'Valor neto del pedido',
      deliveryCount: 'Notas de entrega',
      deliveryValue: 'Valor neto del albarán',
      invoiceCount: 'Facturas registradas',
      averageOrderValue: 'Valor promedio del pedido',
      quoteToOrderConversionPct: 'Conversión de cotización a pedido',
      orderToInvoiceConversionPct: 'Conversión de pedido a factura',
      averageQuoteToOrderDays: 'Duración de cotización a pedido',
      averageOrderToInvoiceDays: 'Duración de pedido a factura',
      wonQuoteCount: 'Cotizaciones ganadas',
      lostQuoteCount: 'Cotizaciones perdidas',
      averageDiscountPct: 'Tasa promedio de descuento',
      cancellationRatePct: 'Tasa de corrección',
      fullyPaidInvoiceRatePct: 'Participación de facturas pagadas en su totalidad',
      totalCalls: 'Llamadas CTI',
      inboundCalls: 'Llamadas entrantes',
      outboundCalls: 'Llamadas salientes',
      answeredCalls: 'Llamadas contestadas',
      missedCalls: 'Llamadas entrantes perdidas',
      notReachedCalls: 'Llamadas salientes no alcanzadas',
      failedCalls: 'Llamadas fallidas',
      voicemailCalls: 'Llamadas al buzón de voz',
      reachabilityPct: 'Tasa de alcanzabilidad',
      totalCallDurationSeconds: 'Duración total de llamadas',
      averageCallDurationSeconds: 'Duración promedio de llamadas',
      longestCallSeconds: 'Llamada más larga',
      uniquePartnerContacts: 'Contactos únicos de socios comerciales',
      unknownPhoneNumbers: 'Números de teléfono no asignados',
      callsPerWorkday: 'Llamadas por día laborable',
      manualCallCount: 'Llamadas manuales de clientes',
      partnerAssignedCallPct: 'Llamadas con socios comerciales',
      technicallyProcessedCallPct: 'Llamadas procesadas técnicamente',
      servedCustomerCount: 'Clientes activos atendidos',
      newCustomerCount: 'Nuevos clientes',
      reactivatedCustomerCount: 'Clientes reactivados',
      newCustomerRevenue: 'Ingresos de nuevos clientes',
      existingCustomerRevenue: 'Ingresos de clientes existentes',
      revenuePerCustomer: 'Ingreso por cliente atendido',
      sentEmailCount: 'Documentos y correos enviados',
      sentWhatsAppCount: 'Mensajes de WhatsApp enviados',
      noteCount: 'Notas de cliente documentadas',
      openFollowUpCount: 'Seguimientos abiertos',
      overdueFollowUpCount: 'Seguimientos vencidos',
      callToQuoteConversionPct: 'Conversión de llamada a cotización',
      callToOrderConversionPct: 'Conversión de llamada a pedido',
      netRevenueComparison: 'Cambio de ingresos respecto al período de comparación',
    },
    definitions: {
      netRevenue:
        'Facturas en PUBLICADO, COMPLETADO o CANCELADO menos cancelaciones contabilizadas y notas de crédito. Se excluyen borradores, documentos eliminados y borradores cancelados aislados. Document.documentDate y la instantánea auditable de atribución de ventas son las fuentes autorizadas.',
      grossRevenue:
        'La misma población calificada que los ingresos netos facturados, usando Document.grossTotal incluyendo impuestos; las cancelaciones contabilizadas y las notas de crédito se deducen como correcciones brutas negativas.',
      paidNetRevenue:
        'Participación de ingresos netos proporcional al paidAmount almacenado en relación con el importe bruto. El modelo de datos no tiene un registro confiable de la hora de pago del cliente, por lo que no se informa la duración promedio de pago.',
      openInvoiceAmount:
        'Montos brutos positivos restantes de las facturas relevantes con ESTADO_ABIERTO, PARCIALMENTE_PAGADO o VENCIDO en el estado de datos actual.',
      overdueInvoiceAmount:
        'Saldos brutos abiertos cuya fecha de vencimiento precede a hoy en la zona horaria del arrendatario.',
      correctionValue:
        'Valor neto de los documentos de CANCELACIÓN y NOTA_DE_CRÉDITO contabilizados como corrección negativa. La factura fuente se conserva para preservar la contrapartida auditable.',
      correctionCount:
        'Número de documentos de CANCELACIÓN y NOTA_DE_CRÉDITO contabilizados por Document.documentDate y la atribución de ventas auditable.',
      costOfGoods:
        'DocumentItem.precioDeCosto × cantidadBase sumado a través de los ítems de factura relevantes para ingresos; los costos de los ítems de cancelación y nota de crédito se revierten como valores negativos.',
      grossProfit:
        'Ingresos netos facturados incluyendo correcciones menos precioDeCosto × cantidadBase a través de los ítems de documentos relacionados.',
      marginPct:
        'Beneficio bruto dividido por los ingresos netos facturados × 100; indefinido cuando los ingresos son cero.',
      averageInvoiceValue:
        'Suma de los valores netos de las facturas relevantes antes de los documentos de corrección dividida por el número de esas facturas.',
      revenueSharePct:
        'Los ingresos netos facturados por el empleado divididos por los ingresos netos del equipo actualmente filtrado, incluyendo valores visibles no asignados, multiplicado por 100.',
      orderIntake:
        'Valor neto de los pedidos en CONFIRMADO, EN_PROCESO, PARCIALMENTE_PROCESADO o COMPLETADO según Document.documentDate.',
      quoteCount:
        'Número de cotizaciones en ENVIADO, ACEPTADO o RECHAZADO según Document.documentDate y el snapshot auditable de atribución de ventas.',
      quoteValue:
        'Suma de los valores netos de estas cotizaciones calificadas según Document.documentDate y atribución de ventas.',
      orderCount:
        'Número de pedidos en CONFIRMADO, EN_PROCESO, PARCIALMENTE_PROCESADO o COMPLETADO según Document.documentDate.',
      orderValue:
        'Suma de los valores netos de los pedidos que cumplen los requisitos; esto equivale a la entrada de pedidos reportada.',
      deliveryCount:
        'Número de notas de entrega en ENVIADO o COMPLETADO por Document.documentDate y atribución de ventas.',
      deliveryValue:
        'Suma de los valores netos de las notas de entrega en ENVIADO o COMPLETADO por Document.documentDate y atribución de ventas.',
      invoiceCount:
        'Número de facturas en REGISTRADO o COMPLETADO por Document.documentDate; los documentos de corrección se cuentan por separado.',
      averageOrderValue:
        'Valor neto de los pedidos que cumplen los requisitos dividido por su cantidad; cero cuando no hay pedidos.',
      quoteToOrderConversionPct:
        'Participación de las cotizaciones relevantes con al menos un pedido que cumple los requisitos cuyo sourceDocumentId apunta exactamente a la cotización.',
      orderToInvoiceConversionPct:
        'Participación de los pedidos relevantes con una factura que cumple los requisitos, ya sea directamente o a través de una nota de entrega en el flujo actual de sourceDocumentId.',
      averageQuoteToOrderDays:
        'Promedio de días calendario desde la fecha del documento de cotización hasta la primera orden de seguimiento calificada en el flujo de documentos.',
      averageOrderToInvoiceDays:
        'Promedio de días calendario desde la fecha del documento de pedido hasta la primera factura calificada, directamente o a través de una nota de entrega.',
      wonQuoteCount:
        'Número de cotizaciones calificadas con estado ACEPTADO según Document.documentDate y atribución de ventas.',
      lostQuoteCount:
        'Número de cotizaciones calificadas con estado RECHAZADO según Document.documentDate y atribución de ventas.',
      averageDiscountPct:
        'Descuentos en encabezado y línea otorgados en pedidos calificados divididos por su valor neto previo al descuento × 100.',
      cancellationRatePct:
        'Número de documentos de cancelación/nota de crédito publicados dividido por facturas más documentos de corrección × 100.',
      fullyPaidInvoiceRatePct:
        'Facturas relevantes con EstadoDePago PAGADO dividido por todas las facturas relevantes × 100.',
      totalCalls:
        'registros únicos de CommunicationLog por iniciadoAt en la zona horaria del inquilino y CommunicationLog.userId. El registro de llamadas no está fusionado.',
      inboundCalls: 'registra CTI con CommunicationLog.direction = INBOUND por startedAt y userId.',
      outboundCalls:
        'registros CTI con CommunicationLog.direction = SALIDA por startedAt y userId.',
      answeredCalls: 'registros CTI con CommunicationLog.status = RESPONDIDO.',
      missedCalls: 'Registros CTI entrantes con estado PERDIDO.',
      notReachedCalls:
        'Registros CTI salientes con estado PERDIDO; estas permanecen separadas de las llamadas entrantes perdidas.',
      failedCalls: 'registros CTI con CommunicationLog.status = FALLIDO.',
      voicemailCalls: 'registros CTI con CommunicationLog.status = BUZÓN de voz.',
      reachabilityPct:
        'Respondió llamadas CTI divididas entre resultados completados atendidos, perdidos, no contactados, buzón de voz y fallidos × 100.',
      totalCallDurationSeconds:
        'Suma de CommunicationLog.durationSeconds en todas las llamadas CTI durante el período; se excluyen los registros manuales de CallLog.',
      averageCallDurationSeconds:
        'Promedio de CommunicationLog.durationSeconds solo para llamadas CTI respondidas.',
      longestCallSeconds:
        'El valor más alto de CommunicationLog.durationSeconds almacenado en el período seleccionado.',
      uniquePartnerContacts:
        'Número de socios comerciales distintos resueltos a través de CommunicationLog.partnerId.',
      unknownPhoneNumbers:
        'Número de números de teléfono externos distintos de llamadas CTI sin un CommunicationLog.partnerId resuelto; los números en sí no se devuelven.',
      callsPerWorkday:
        'Recuento de llamadas CTI dividido por los lunes a viernes en el rango del calendario del inquilino seleccionado; no se asumen feriados.',
      manualCallCount:
        'Llamadas de clientes documentadas manualmente desde CallLog contadas por separado según occurredAt y userId; nunca se combinan con registros CTI.',
      partnerAssignedCallPct:
        'Llamadas CTI con un CommunicationLog.partnerId resuelto dividido por todas las llamadas CTI × 100.',
      technicallyProcessedCallPct:
        'Registros CTI con endedAt y un estado diferente de RINGING dividido por todos los registros CTI × 100.',
      servedCustomerCount:
        'Socios comerciales activos distintos con un documento calificado o contacto CTI atribuido por el empleado durante el período.',
      newCustomerCount:
        'Clientes distintos cuya primera factura calificada se encuentra en el período seleccionado y se atribuye al empleado.',
      reactivatedCustomerCount:
        'Clientes distintos con una nueva factura calificada después de al menos 180 días calendario sin una factura calificada.',
      newCustomerRevenue:
        'Ingresos netos facturados incluyendo correcciones de clientes cuya primera factura calificada se encuentra dentro del período seleccionado.',
      existingCustomerRevenue:
        'Ingresos netos facturados incluyendo correcciones de clientes cuya primera factura calificada predates el período seleccionado.',
      revenuePerCustomer:
        'Ingresos netos facturados divididos por clientes activos atendidos; cero cuando no hay clientes.',
      sentEmailCount:
        'Registros de EmailLog exitosos con estado ENVIADO por sentAt y sentByUserId; se aplican filtros de documento y cliente.',
      sentWhatsAppCount:
        'Registros de WhatsAppMessage salientes en ENVIADO, ENTREGADO o LEÍDO por sentAt o createdAt y senderUserId.',
      noteCount: 'Registros de CustomerNote por occurredAt y authorId en el período seleccionado.',
      openFollowUpCount:
        'Notas de clientes del período con followUpAt y sin followUpDoneAt en el estado actual de los datos.',
      overdueFollowUpCount:
        'Seguimientos abiertos de notas de clientes en el período cuyo followUpAt ha pasado.',
      callToQuoteConversionPct:
        'Porcentaje de llamadas CTI seguidas por una cotización calificada para el mismo socio comercial y empleado dentro del período configurado. Esta es atribución temporal, no causalidad comprobada.',
      callToOrderConversionPct:
        'Porcentaje de llamadas CTI seguidas por un pedido calificado para el mismo socio comercial y empleado dentro de la ventana configurada. Esto es atribución temporal, no causalidad comprobada.',
      netRevenueComparison:
        'Cambio porcentual en los ingresos netos facturados en comparación con el período anterior o el mismo período del año pasado. No se define ningún porcentaje cuando el valor de comparación es cero.',
    },
  },
};
